<div class="criteria-address-fields" [formGroup]="addressForm" [ngClass]="noFieldsEnabled ? 'empty-address-criteria' : 'populated-address-criteria'">
  <ul>
    <li class="add-another-address-row">
      <h3>
        <span>Choose operator: </span>
        <form [formGroup]="formGroup">
          <mat-select class="full-width" formControlName="operator" (selectionChange)="operatorChange($event)">
            <mat-option *ngFor="let op of operators" value="{{op.value}}" >{{op.label}}</mat-option>
          </mat-select>
        </form>
        <span *ngIf="noFieldsEnabled; else addAnother">Choose an address field:</span>
        <ng-template #addAnother><span>Add another address field:</span></ng-template>
        <mat-select [formControl]="fieldSelected" class="add-another-address-dropdown full-width" (selectionChange)="addNewAddressField($event)" placeholder="Choose field..." [ngClass]="{disabled : allFieldsEnabled}">
          <mat-option *ngFor="let fieldNotAdded of filterAddresses(false)" [value]="fieldNotAdded">
            {{fieldNotAdded.name}} ({{fieldNotAdded.controlName}})
          </mat-option>
        </mat-select>
      </h3>
    </li>
    <li [formGroup]="addressForm" *ngFor="let field of filterAddresses(true)" id="field.controlName" [ngClass]="{'country-enabled' : countryAddressField.enabled}">
      <div *ngIf="field.name !== 'Country'">
        <i class="bhi-times remove-criteria-composite-" (click)="removeAddressField(field)" [matTooltip]="'Remove this field'" matTooltipShowDelay="500"></i>
        <h3>{{field.name}}</h3>
        <mat-select class="full-width" [value]="operatorSelected" [disabled]="true">
          <mat-option *ngFor="let op of operators" value="{{op.value}}">{{op.label}}</mat-option>
        </mat-select>
        <ng-container
                *ngIf="formGroup.get('operator').value !== 'equals' && formGroup.get('operator').value !== 'notEquals' else showInput">
        </ng-container>
        <ng-template #showInput>
          <input formControlName="{{field.controlName}}" [placeholder]="'Enter text...'" required>
          <span *ngIf="infoMessage" class="material-icons notranslate tooltip-icon info" matTooltip="{{infoMessage}}" matTooltipClass="mat-tooltip">help_outline</span>
        </ng-template>
        <ng-container
                *ngIf="formGroup.get('operator').value !== 'in' && formGroup.get('operator').value !== 'notIn' else showChipInput">
        </ng-container>
        <ng-template #showChipInput>
          <mat-chip-grid #chipList formControlName="{{field.controlName}}" (click)="clickEventChipComponent()">
            <mat-chip-row *ngFor="let val of field.control.value" removable="true"
                      (removed)="removeInValue(field,val)" >
              {{val}}
              <mat-icon matChipRemove>close</mat-icon>
            </mat-chip-row>
            <input placeholder="value" [matChipInputFor]="chipList" [matChipInputAddOnBlur]="true"
                   [matChipInputSeparatorKeyCodes]="[13,188]" (matChipInputTokenEnd)="addInValue(field,$event)">
          </mat-chip-grid>
        </ng-template>

      </div>
      <div *ngIf="field.name === 'Country'">
        <i class="bhi-times" (click)="removeAddressField(countryAddressField)" [matTooltip]="'Remove this field'" matTooltipShowDelay="500"></i>
        <h3>Country</h3>
        <mat-select class="full-width" [value]="operatorSelected" [disabled]="true">
          <mat-option *ngFor="let op of operators" value="{{op.value}}">{{op.label}}</mat-option>
        </mat-select>
        <ng-container
                *ngIf="formGroup.get('operator').value !== 'equals' && formGroup.get('operator').value !== 'notEquals' else showInput">
        </ng-container>
        <ng-template #showInput>
          <app-autocomplete #countryField [selectedOptionControl]="countryControl" [inputRequired]="true"
                            [componentId]="'country--criteria-fieldValue'"></app-autocomplete>
        </ng-template>
        <ng-container
                *ngIf="formGroup.get('operator').value !== 'in' && formGroup.get('operator').value !== 'notIn' else showChipInput">
        </ng-container>
        <ng-template #showChipInput>
          <app-chip-list-autocomplete #chipCountryField [valueControl]="countryControl"></app-chip-list-autocomplete>
        </ng-template>
      </div>
    </li>
  </ul>
<!--  addressForm: {{addressForm.value | json}} | valid={{addressForm.valid}}, dirty={{addressForm.dirty}}-->
<!--  <br>-->
<!--  formGroup: {{formGroup.value | json}} | valid={{formGroup.valid}}, dirty={{formGroup.dirty}}-->
</div>
